import { lazy } from 'react'
import PlayerTransferValue from './Admin/PointTransfer/PlayerTransferValue.jsx'
import UnsubscribeEmail from './Pages/UnsubscribeEmail.jsx'
import Loading from './Component/Loading.jsx'
import FixturesIndex from './Fixtures/FixturesIndex.jsx'
import AdsRoute from './Advertisement/AdsRoute.jsx'
import StreakDetails from './streak/StreakDetails.jsx'

// pages
import Home from './HomePage/Home.jsx'
const SignIn = lazy(() => import('./Pages/SignIn.jsx'))
const SignUp = lazy(() => import('./Pages/SignUp.jsx'))
const ForgotPassword = lazy(() => import('./Pages/ForgotPassword.jsx'))
const Logout = lazy(() => import('./Pages/Logout.jsx'))
const ChangePassword = lazy(() => import('./Pages/ChangePassword.jsx'))
const ChangePasswordOTP = lazy(() => import('./Pages/ChangePasswordOTP.jsx'))
const EmailVerification = lazy(() => import('./Pages/EmailVerification.jsx'))
const AliasCodeHandler = lazy(() => import('./Pages/AliasCodeHandler.jsx'))

const Dashboard = lazy(() => import('./Dashboard/Dashboard.jsx'))
const Profile = lazy(() => import('./Profile/Profile.jsx'))
const Refer = lazy(() => import('./Refer/Refer.jsx'))
const GlobalLeaderBoard = lazy(
  () => import('./GlobalLeaderBoard/GlobalLeaderBoard.jsx')
)
const Streak = lazy(() => import('./streak/Streak.jsx'))

// gameroom
import GameRooms from './GameRoom/GameRooms.jsx'
const AllLeagues = lazy(() => import('./GameRoom/AllLeagues.jsx'))
const GRDetails = lazy(() => import('./GameRoom/GRDetails.jsx'))
const JoinedGames = lazy(() => import('./JoinedGames/JoinedGames.jsx'))

// team
const MyTeams = lazy(() => import('./MyTeams/MyTeams.jsx'))
const CreateTeam = lazy(() => import('./MyTeams/CreateTeam.jsx'))
const Wallet = lazy(() => import('./wallet/Wallet.jsx'))

// admin
const AdminDashboard = lazy(() => import('./Admin/AdminDashboard.jsx'))
const AdminLeague = lazy(() => import('./Admin/AdminLeague/AdminLeague.jsx'))
const AdminNotification = lazy(
  () => import('./Admin/AdminNotification/AdminNotification.jsx')
)
const CreateGR = lazy(() => import('./Admin/AdminGameRoom/CreateGR.jsx'))
const GRList = lazy(() => import('./Admin/AdminGameRoom/GRList.jsx'))
const AdminBalances = lazy(
  () => import('./Admin/AdminBalances/AdminBalances.jsx')
)
const AdminStatement = lazy(
  () => import('./Admin/AdminBalances/AdminStatement.jsx')
)
const AdminNegativeBalances = lazy(
  () => import('./Admin/AdminBalances/AdminNegativeBalances.jsx')
)
const AdminMyGames = lazy(
  () => import('./Admin/AdminGameRoom/AdminGames/AdminMyGames.jsx')
)

// creator Hub
const CreatorHub = lazy(() => import('./CreatorHub/CreatorHub.jsx'))
const BrandAssets = lazy(() => import('./BrandAssets/BrandAssets.jsx'))
const CreatorCreateGR = lazy(() => import('./CreatorHub/CreatorCreateGR.jsx'))

export const Routings = [
  {
    id: 1,
    path: '/loading',
    element: 'Loading',
    userType: 'public',
    importFrom: Loading,
    layout: 'public',
    title: 'Loading',
  },
  {
    id: 2,
    path: '/',
    element: 'Home',
    userType: 'public',
    importFrom: Home,
    layout: 'public',
    title: 'Home',
  },
  {
    id: 3,
    path: '/sign-in',
    element: 'SignIn',
    userType: 'public',
    importFrom: SignIn,
    layout: 'public',
    title: 'Sign In',
  },
  {
    id: 4,
    path: '/sign-up',
    element: 'SignUp',
    userType: 'public',
    importFrom: SignUp,
    layout: 'public',
    title: 'Sign Up',
  },
  {
    id: 5,
    path: '/forgot-password',
    element: 'ForgotPassword',
    userType: 'public',
    importFrom: ForgotPassword,
    layout: 'public',
    title: 'Forgot Password',
  },
  {
    id: 6,
    path: '/change-password',
    element: 'ChangePassword',
    userType: 'public',
    importFrom: ChangePassword,
    layout: 'public',
    title: 'Change Password',
  },
  {
    id: 7,
    path: '/logout',
    element: 'Logout',
    userType: 'public',
    importFrom: Logout,
    layout: 'public',
    title: 'Logout',
  },
  {
    id: 9,
    path: '/change-passwordOTP',
    element: 'ChangePasswordOTP',
    userType: 'public',
    importFrom: ChangePasswordOTP,
    layout: 'public',
    title: 'Change Password OTP',
  },
  {
    id: 10,
    path: '/email-verification',
    element: 'EmailVerification',
    userType: 'public',
    importFrom: EmailVerification,
    layout: 'public',
    title: 'Email Verification',
  },
  {
    id: 11,
    path: '/leagues',
    element: 'AllLeagues',
    userType: 'public',
    importFrom: AllLeagues,
    layout: 'dynamic',
    title: 'All Leagues',
  },
  {
    id: 12,
    path: '/game-rooms',
    element: 'GameRooms',
    userType: 'public',
    importFrom: GameRooms,
    layout: 'dynamic',
    title: 'Game Rooms',
  },
  {
    id: 14,
    path: '/wallet',
    element: 'Wallet',
    userType: 'user',
    importFrom: Wallet,
    isProtected: true,
    layout: 'user',
    title: 'Wallet',
  },
  {
    id: 15,
    path: '/my-teams',
    element: 'MyTeams',
    userType: 'user',
    importFrom: MyTeams,
    layout: 'user',
    title: 'My Teams',
  },
  {
    id: 16,
    path: '/create-team',
    element: 'CreateTeam',
    userType: 'user',
    importFrom: CreateTeam,
    layout: 'user',
    title: 'Create Team',
  },
  {
    id: 17,
    path: '/admin',
    element: 'AdminDashboard',
    userType: 'admin',
    importFrom: AdminDashboard,
    isProtected: true,
    layout: 'admin',
    title: 'Admin Dashboard',
  },
  {
    id: 18,
    path: '/admin-league',
    element: 'AdminLeague',
    userType: 'admin',
    importFrom: AdminLeague,
    isProtected: true,
    layout: 'admin',
    title: 'Admin League',
  },
  {
    id: 20,
    path: '/game-rooms/:id',
    element: 'GRDetails',
    userType: 'user',
    importFrom: GRDetails,
    layout: 'dynamic',
    title: 'Game Room Details',
  },
  {
    id: 21,
    path: '/joined-games',
    element: 'JoinedGames',
    userType: 'user',
    importFrom: JoinedGames,
    isProtected: true,
    layout: 'user',
    title: 'Joined Games',
  },
  {
    id: 22,
    path: '/dashboard',
    element: 'Dashboard',
    userType: 'user',
    importFrom: Dashboard,
    isProtected: true,
    layout: 'user',
    title: 'Dashboard',
  },
  {
    id: 23,
    path: '/player-transfer-value',
    element: 'PlayerTransferValue',
    userType: 'admin',
    importFrom: PlayerTransferValue,
    isProtected: true,
    layout: 'admin',
    title: 'Player Transfer Value',
  },
  {
    id: 24,
    path: '/profile',
    element: 'Profile',
    userType: 'user',
    importFrom: Profile,
    isProtected: true,
    layout: 'user',
    title: 'Profile',
  },
  {
    id: 25,
    path: '/refer',
    element: 'Refer',
    userType: 'user',
    importFrom: Refer,
    isProtected: true,
    layout: 'user',
    title: 'Refer',
  },
  {
    id: 26,
    path: '/global-leader-board',
    element: 'GlobalLeaderBoard',
    userType: 'user',
    importFrom: GlobalLeaderBoard,
    isProtected: false,
    layout: 'dynamic',
    title: 'Global Leader Board',
  },
  {
    id: 27,
    path: '/unsubscribe',
    element: 'UnsubscribeEmail',
    userType: 'public',
    importFrom: UnsubscribeEmail,
    isProtected: false,
    layout: 'public',
    title: 'Unsubscribe',
  },
  {
    id: 28,
    path: '/admin-notification',
    element: 'AdminNotification',
    userType: 'admin',
    importFrom: AdminNotification,
    isProtected: true,
    layout: 'admin',
    title: 'Admin Notification',
  },
  {
    id: 29,
    path: '/pfc/:aliasCode',
    element: 'AliasCodeHandler',
    userType: 'public',
    importFrom: AliasCodeHandler,
    isProtected: false,
    layout: 'public',
    title: 'Alias Code Handler',
  },
  {
    id: 30,
    path: '/admin-create-game-room',
    element: 'CreateGR',
    userType: 'admin',
    importFrom: CreateGR,
    isProtected: true,
    layout: 'admin',
    title: 'Create Game Room',
  },
  {
    id: 31,
    path: '/admin-game-room-list',
    element: 'GRList',
    userType: 'admin',
    importFrom: GRList,
    isProtected: true,
    layout: 'admin',
    title: 'Admin Game Room List',
  },
  {
    id: 32,
    path: '/fixtures',
    element: 'Fixtures',
    userType: 'public',
    importFrom: FixturesIndex,
    layout: 'dynamic',
    title: 'Fixtures',
  },
  {
    id: 33,
    path: '/ads-route',
    element: 'AdsRoute',
    userType: 'public',
    importFrom: AdsRoute,
    layout: 'public',
    title: 'Ads Route',
  },
  {
    id: 34,
    path: '/streak',
    element: 'Streak',
    userType: 'user',
    importFrom: Streak,
    layout: 'user',
    title: 'Streak',
  },
  {
    id: 35,
    path: '/streak-details/:streakId',
    element: 'StreakDetails',
    userType: 'user',
    importFrom: StreakDetails,
    layout: 'user',
    title: 'Streak Details',
  },
  {
    id: 36,
    path: '/admin-balances',
    element: 'AdminBalances',
    userType: 'admin',
    importFrom: AdminBalances,
    isProtected: true,
    layout: 'admin',
    title: 'Admin Balances',
  },
  {
    id: 37,
    path: '/admin-statement/:userId',
    element: 'AdminStatement',
    userType: 'admin',
    importFrom: AdminStatement,
    isProtected: true,
    layout: 'admin',
    title: 'Admin Statement',
  },
  {
    id: 38,
    path: '/admin-negative-balances',
    element: 'AdminNegativeBalances',
    userType: 'admin',
    importFrom: AdminNegativeBalances,
    isProtected: true,
    layout: 'admin',
    title: 'Admin Negative Balances',
  },
  {
    id: 39,
    path: '/creator-hub',
    element: 'CreatorHub',
    userType: 'user',
    importFrom: CreatorHub,
    isProtected: true,
    layout: 'user',
  },
  {
    id: 40,
    path: '/brand-assets',
    element: 'BrandAssets',
    userType: 'user',
    importFrom: BrandAssets,
    isProtected: true,
    layout: 'user',
  },
  {
    id: 41,
    path: '/creator-create-game-room',
    element: 'CreatorCreateGR',
    userType: 'user',
    importFrom: CreatorCreateGR,
    isProtected: true,
    layout: 'user',
  },
  {
    id: 42,
    path: '/admin-my-games',
    element: 'AdminMyGames',
    userType: 'admin',
    importFrom: AdminMyGames,
    isProtected: true,
    layout: 'admin',
  },
]
